module.exports = __webpack_public_path__ + "img/gift_box.64729abb.png";